import { useSelector } from "react-redux";
import "./Loader.scss";
import meiLogoColored from "../../assets/meilogo.png";
import { RootState } from "../../service/store";

const Loader = ({loading=false}: {loading?: boolean}) => {
  const loader = useSelector((state: RootState) => state.static.loader);
  return (
    <>
      {(loading || loader) && (
        <div className="mei-logo-spinner-wrapper">
        <div className="loader-overlay"></div>
        <div className="mei-logo-spinner-container position-absolutes">
            <img src={meiLogoColored} alt='' className="mei-logo-spinner" />
        </div>
    </div>
      )}
    </>
  );
};
export default Loader;
